import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import '../styles/Header.css';

const Header = ({ onMenuToggle, menuOpen }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="page-header">
      <div className="header-content">
        <div className="header-left">
          <button 
            className="mobile-menu-toggle" 
            onClick={onMenuToggle}
            aria-label="Toggle menu"
          >
            {menuOpen ? '✕' : '☰'}
          </button>
          <h1 className="page-title">Enquiry Management System</h1>
        </div>
        <div className="header-right">
          <span className="user-email">{user?.email || ''}</span>
          <button onClick={handleLogout} className="btn btn-outline">
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;

